'use client';
import React, { useState } from 'react';
import styles from './scss/segmentation.module.scss';
import Churn1 from './Churn1';
import Churn2 from './Churn2';
import Churn3 from './churn3';
import Churn4 from './churn4';

const ChurnPrediction = ({ onComplete }: { onComplete?: () => void }) => {
  const [seg1Done, setSeg1Done] = useState(false);
  const [seg2Done, setSeg2Done] = useState(false);

  return (
    <div className={styles.segmentationsec}>
      <p className={styles.paratxt}>
        Customers by shared traits to deliver <br /> targeted experiences.
      </p>

      <Churn1 onComplete={() => setSeg1Done(true)} />
        <div className={styles.chartandsummary}>
            {seg1Done && <Churn2 onComplete={() => setSeg2Done(true)} />}
            {seg2Done && <Churn3 onComplete={onComplete} />}
        </div>
    </div>
  );
};

export default ChurnPrediction;